import { useCallback, useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { managementApiRef } from '@internal/plugin-management';
import { getHomeTipCandidates, selectHomeTip } from '../homeUtils';
import type { Tip } from '@internal/plugin-management-common';

export function useHomeDailyTip(): Tip | undefined {
  const managementApi = useApi(managementApiRef);
  const [tips, setTips] = useState<Tip[]>([]);
  const [tipOfTheDay, setTipOfTheDay] = useState<Tip>();

  const fetchTips = useCallback(async () => {
    try {
      setTips(await managementApi.listTips());
    } catch (error) {
      console.error('Error fetching home tips:', error);
      setTips([]);
    }
  }, [managementApi]);

  useEffect(() => {
    void fetchTips();
    const interval = window.setInterval(fetchTips, 45000);
    window.addEventListener('focus', fetchTips);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener('focus', fetchTips);
    };
  }, [fetchTips]);

  useEffect(() => {
    setTipOfTheDay(current => {
      const candidates = getHomeTipCandidates(tips);
      return (
        candidates.find(tip => tip.id === current?.id) ?? selectHomeTip(tips)
      );
    });
  }, [tips]);

  return tipOfTheDay;
}
